export default __webpack_public_path__ + "static/media/Logo_SVG_black.ce949632.svg";